'use client'

import React from 'react'
import { useTenant } from '@/components/TenantLayout/Client'
import RichText from '@/components/RichText'
import { hasRichTextContent } from '@/utilities/richText'

export function Footer() {
  const { tenant } = useTenant()
  // Return null if no tenant is available
  if (!tenant?.footerContent || !hasRichTextContent(tenant?.footerContent)) {
    return null
  }

  return (
    <footer className="print:hidden border-t border-gray-200 bg-tenant-background">
      <div>
        <div className="my-4 mx-24">
          <RichText data={tenant?.footerContent} enableProse={true} enableGutter={false} />
        </div>
      </div>
    </footer>
  )
}
